import React from 'react';
import Map from '../../Map/Map';
import Classes from '../ProfileSidebar.scss';

const ProfileStaticMap = ({ latitude, longitude }: { latitude: number; longitude: number }) => (
  <div className={Classes.mapContainer}>
    <Map
      latitude={latitude}
      longitude={longitude}
      center={{ lat: latitude, lng: longitude }}
      zoom={11}
      options={{ draggable: false }}
      standardMarkerProps={{
        clickable: true,
      }}
    />
  </div>
);

export default ProfileStaticMap;
